import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import APIClient from './../../helpers/ApiClient';
import config from './../../config';
// import { RootState } from './../store'

// const config = getConfig().publicRuntimeConfig;

export const initialState: any = {
   navOpen: false,
   geosOpen: false,
   selectedChannel: 'Advertising',
   selectedCompareCountriesTopic: null,
   selectedGeography: 'United States',
   id: '59e8edccbfce890eb411ef5b',
   geoId: '221',
   channels: [],
   compareCountries: [],
   geographies: [],
   error: null
};

// Thunk API Calls
export const navigation_load_geo_list = createAsyncThunk('get/navmenubygeography', async () => {
   const res = await APIClient(`get`, `${config.apiHost}/navmenubygeography`);

   return await res.data;
});

export const navigation_load_menu = createAsyncThunk('get/navmenubygeography/id', async (id: string) => {
   const res = await APIClient(`get`, `${config.apiHost}/navmenubygeography/${id}`);

   return await res.data;
});

export const navigationSlice = createSlice({
   name: 'navigation',
   initialState,
   reducers: {
      navigation_toggle_open: state => {
         state.navOpen = true;
      },
      navigation_toggle_close: (state, action: PayloadAction<string>) => {
         state.navOpen = false;
         state.selectedGeography = action.payload === '' ? 'Compare Countries' : action.payload;
      },
      navigation_close_on_submit: (state, action: PayloadAction<number>) => {
         state.navOpen = false;
      },
      navigation_select_channel: (state, action: PayloadAction<{ channel: string; isMobile: boolean }>) => {
         if (state.selectedChannel === action.payload.channel && action.payload.isMobile) {
            state.selectedChannel = '';
         } else if (action.payload.channel.indexOf('Compare Countries') !== -1) {
            // Check to see if it is for all Compare Countries or a specific Compare Countries Topic
            const compareCountriesArray = action.payload.channel.split(':');
            state.selectedChannel = 'Compare Countries';

            if (compareCountriesArray.length === 2) {
               state.selectedCompareCountriesTopic = compareCountriesArray[1].trim();
            }
         } else {
            state.selectedChannel = action.payload.channel;
            state.selectedCompareCountriesTopic = null;
         }
      },
      navigation_geo_toggle_open: state => {
         state.geosOpen = true;
      },
      navigation_geo_toggle_close: state => {
         state.geosOpen = false;
      },
      navigation_geo_select_geo: (state, action: PayloadAction<string>) => {
         state.selectedGeography = action.payload === '' ? 'Compare Countries' : action.payload;
      }
   },
   extraReducers: builder => {
      builder.addCase(HYDRATE, (state, action: any) => {
         return {
            ...state,
            ...action.payload.navigation
         };
      }),
         builder.addCase(navigation_load_geo_list.fulfilled, (state, action) => {
            state.geographies = action.payload;
         }),
         builder.addCase(navigation_load_geo_list.rejected, (state, action) => {
            state.error = action.error;
         }),
         builder.addCase(navigation_load_menu.pending, (state, action) => {
            state.id = action.meta.arg;
            state.geoId = '';
            state.channels = [];
            state.compareCountries = [];
            state.loading = true;
            state.loaded = false;
         }),
         builder.addCase(navigation_load_menu.fulfilled, (state, action) => {
            const selectedChannel = action.payload.Topics.length > 0 ? action.payload.Topics[0].TopicName : 'Compare Countries';
            state.id = action.payload.Id;
            state.geoId = action.payload.GeoId;
            state.selectedChannel = selectedChannel;
            state.channels = action.payload.Topics;
            state.compareCountries = action.payload.MultiGeoTopics;
            state.loading = false;
            state.loaded = true;
         }),
         builder.addCase(navigation_load_menu.rejected, (state, action) => {
            state.error = action.error;
            state.loading = false;
            state.loaded = true;
         });
   }
});

// Select Property
export const selectOpenNav = state => state.navigation.navOpen;
export const selectSelectedGeography = state => state.navigation.selectedGeography;
export const selectLoading = state => state.navigation.loading;

// Action creators are generated for each case reducer function
export const {
   navigation_toggle_open,
   navigation_toggle_close,
   navigation_close_on_submit,
   navigation_select_channel,
   navigation_geo_toggle_open,
   navigation_geo_toggle_close,
   navigation_geo_select_geo
} = navigationSlice.actions;

export default navigationSlice.reducer;
